import { captureException, captureMessage } from '@sentry/nextjs'

import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'

import { PAGE_SIZE } from '@/app/(plp)/constants'
import { TIMEOUT } from '@/app/_constants/fetch-config'
import { REMOTE_API_BASE_URL } from '@/app/_constants/urls'
import { IS_ON_SERVER, getServiceUrl } from '@/app/_utils/select-api-service'

import { generateSearchParams } from '@/utils/generate-search-params'

import { setUrlParams } from '../../_utils/set-url-params'
import { PLPPageProps } from '../types'

export async function getProductsList(params: PLPPageProps['searchParams'], isServerSideRequest = false) {
    const baseUrl = getServiceUrl('ntl')

    const searchParams = generateSearchParams(params || {})

    !params?.[PRODUCT_QUERY_PARAMS.PAGE_SIZE] && searchParams.set(PRODUCT_QUERY_PARAMS.PAGE_SIZE, String(PAGE_SIZE))

    const url = `${IS_ON_SERVER && isServerSideRequest ? REMOTE_API_BASE_URL : ''}${baseUrl}/products?${searchParams}`
    const finalUrl = setUrlParams(url)

    // eslint-disable-next-line no-console
    process.env.NODE_ENV !== 'production' && console.log('URL ==> %s', finalUrl)

    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT)

    try {
        const response = await fetch(finalUrl, { cache: 'no-cache', signal: controller.signal })

        if (!response.ok) {
            captureMessage('PLP API Response Error', {
                level: 'warning',
                extra: {
                    url: finalUrl,
                    status: response.status,
                    statusText: response.statusText,
                    params,
                },
            })
        }

        const result = await response.json()

        if (!response.ok) {
            if (result.errors[0].code === 'entity.not.found') {
                return null
            } else {
                throw new Error(`Search for ${finalUrl} failed. Status Code: ${response.status}`)
            }
        }

        return result
    } catch (error) {
        captureException(new Error(`PLP API Error: ${error}`), {
            extra: {
                url: finalUrl,
                params,
            },
        })
        throw new Error(`${error}`)
    } finally {
        clearTimeout(timeoutId)
    }
}
